import { Grid,Box,Paper } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import './SignUpForm.css';

function SignUpForm() {

    const [displayText, setDisplayText] = useState("");
    const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    });

    const [showForm, setShowForm] = useState(true);
    const handleSubmit = async (event) => {
    event.preventDefault();
    setShowForm(false);
    setDisplayText(
    "An account verification email has been sent to your email address"
    );

    var data = {
    first_name: form.firstName,
    last_name: form.lastName,
    email_id: form.email,
    platform_type: "web",
    };

    const auth = window.catalyst.auth;
    var signupResponse = await auth.signUp(data);
    debugger;
    if (signupResponse.status == 200) {
        setDisplayText(
            "An account verification email has been sent to your email address"
            );
            setTimeout(function () {
            window.location.href = "index.html";
            }, 3000);
} 

else {
        setDisplayText(
            signupResponse.message
        );
     
        setTimeout(function () {
            window.location.href = "index.html";
            }, 3000);
        }
};
    return (

       <div id="signup" className="container">
        <Grid container>
            <Grid item xs={12} sm={6}  className="right-division" >
            <Paper  className="right-content"
                sx={{
                    transform:'translate(100%,10%)',
                    width:'20vw',
                    height:'100%',
                     marginTop:'-10%'
                }}>
            {showForm ? (
            <div className="right-div">
            <form onSubmit={handleSubmit} className="modal-content">
              <center>
                 <h1>Sign Up</h1>
              </center>
              <div className="input-container">
              <label htmlFor="firstName">
                <input
                name="firstName"
                className="inputs"
                placeholder="First Name"
                value={form.firstName}
                onChange={(e) => {
                setForm({...form,
                firstName: e.target.value,
                });
                }}
                required
                />
                </label>


                <label htmlFor="lastName">
                <input
                className="inputs"
                placeholder="Last Name"
                value={form.lastName}
                onChange={(e) => {
                setForm({...form,
                lastName: e.target.value,
                });
                }}
                required
                />
                </label>

                <label htmlFor="email">
                <input
                className="inputs"
                type="email"
                placeholder="Email address"
                value={form.email}
                onChange={(e) => {
                setForm({...form, email: e.target.value});
                }}
                required
                />
                </label>
              </div>
            <center>
            <input type="submit" value="Sign Up" className="signupfnbtn" />
            </center>

        </form>
        <div className="or-divider">or</div>
        <div className="sign-in-link">
            <p>
            Already have an account?{" "}
            <Link
            to="/"
            style={{ color: "black", textDecorationLine: "underline",fontSize:'18px',marginLeft:'5px',fontWeight:'600'}}
            >
            Sign In
            </Link>{" "}
            </p>
        </div>

    </div>
    ) : (
    <p>{displayText}</p>
    )}
            </Paper>
            </Grid>
        </Grid>
           
    </div>
);
}
export default SignUpForm;